import { Factory } from '../utils/job.manager';
import { IOTask } from './abstract.file.system';

export class IoJob<T> {
  protected cancelled = false;
  private activeTask?: IOTask<T>;
  private innerCancelListener = { cancelListener: null };
  private endCalled = false;
  constructor(
    private input: {
      onError: (error: Error) => void;
      worker: Factory<T>;
      onRun: (listener: { cancelListener: Function }, activeTask: IOTask<T>) => Promise<T>;
      onEnd: () => void;
    },
  ) {}

  public cancel = () => {
    this.cancelled = true;

    try {
      this.innerCancelListener.cancelListener?.();
    } catch {}

    if (!this.activeTask) {
      this.notifyEnd();
    }
  };

  private triggerError(error: any) {
    try {
      this.input.onError(error);
    } catch {}
  }

  public run(): IOTask<T> {
    this.activeTask = { cancel: this.cancel } as IOTask<T>;

    this.activeTask.promise = new Promise<T>((resolve) => {
      if (this.cancelled) {
        this.triggerError(new Error('operation cancelled'));
        resolve(undefined);
        return;
      }
      this.activeTask.job = this.input.worker.schedule(async () => {
        if (this.cancelled) {
          this.triggerError(new Error('operation cancelled'));
          resolve(undefined);
          return;
        }
        try {
          resolve(await this.input.onRun(this.innerCancelListener, this.activeTask));
        } catch (e) {
          resolve(undefined);
          this.triggerError(e instanceof Error ? e : new Error(String(e?.message ?? e)));
        }
      });

      if (!this.activeTask.job) {
        this.triggerError(new Error('IO Queue capacity reached'));
        resolve(undefined);
      }
    }).finally(() => {
      this.notifyEnd();
    });

    return this.activeTask;
  }

  private notifyEnd() {
    if (this.endCalled) {
      return;
    }
    this.endCalled = true;
    this.input.onEnd();
  }
}
